<template>
    <div class="tabletBody">
        <div class="container">
            <div class="row">
                <div class="presentation">
                    <img src="/presentations/1.jpg">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "imagePage"
    }
</script>

<style scoped>

</style>